import React, { useEffect } from "react";
import Title from "../Title/Title";
import "./Skills.css";
import { GiSkills } from "react-icons/gi";
import AOS from "aos";
import "aos/dist/aos.css";

//frontend
import ReactIcon from "../../project-icons/frontend/reactjs-icon.png";
import AngularIcon from "../../project-icons/frontend/angular-icon.png";
import NextIcon from "../../project-icons/frontend/nextjs-icon.png";
import VueIcon from "../../project-icons/frontend/vuejs-icon.png";
import TypescriptIcon from "../../project-icons/frontend/typescript-icon.png";
import NodeIcon from "../../project-icons/frontend/nodejs-icon.png";
import RxjsIcon from "../../project-icons/frontend/rxjs.png";
import ReduxIcon from "../../project-icons/frontend/redux-icon.png";
import PiniaIcon from "../../project-icons/frontend/pinia.svg";
import ViteIcon from "../../project-icons/frontend/vite-icon.png";
import PhpIcon from "../../project-icons/frontend/php-logo.png";
import WordpressIcon from "../../project-icons/frontend/wordpress-logo.png";
import WoocommerceIcon from "../../project-icons/frontend/woocommercelogo.png";
import ShopifyIcon from "../../project-icons/frontend/shopify.png";
import OpencartIcon from "../../project-icons/frontend/opencart.png";
import PrestaIcon from "../../project-icons/frontend/prestashop.png";

//backend
import ApiIcon from "../../project-icons/backend/api-icon.png";
import FirebaseIcon from "../../project-icons/backend/firebase-icon.png";
import GraphQLIcon from "../../project-icons/backend/graphql-icon.png";
import HttpIcon from "../../project-icons/backend/http-icon.png";
import SanityIcon from "../../project-icons/backend/sanity-icon.png";
import NestIcon from "../../project-icons/backend/nest-icon.png";
import MongodbIcon from "../../project-icons/backend/mongodb-icon.png";
import MariaDBIcon from "../../project-icons/backend/mariadb-icon.png";
import MysqlIcon from "../../project-icons/backend/mysql-icon.png";
import PostgresqlIcon from "../../project-icons/backend/postgresql-icon.png";
import StripeIcon from "../../project-icons/backend/stripe-logo.png";
import PostmanIcon from "../../project-icons/backend/postman-icon.png";
import GraphCMSIcon from "../../project-icons/backend/graphcms-icon.jpeg";
import TypeOrmIcon from "../../project-icons/backend/typeorm.png";
import PrismaIcon from "../../project-icons/backend/prismadb.png";
import LaravelIcon from "../../project-icons/backend/laravel-icon.png";

//testing
import JestIcon from "../../project-icons/testing/jest-icon.png";
import JasmineIcon from "../../project-icons/testing/jasmine-icon.png";
import CypressIcon from "../../project-icons/testing/cypress-icon.png";
import KarmaIcon from "../../project-icons/testing/karma-icon.png";

//design
import CSSIcon from "../../project-icons/design/css-icon.png";
import Figma from "../../project-icons/design/figma-icon.png";
import MaterialUI from "../../project-icons/design/material-ui.png";
import StyledComponents from "../../project-icons/design/styled-components.png";
import Tailwind from "../../project-icons/design/tailwind-css-icon.png";
import Saas from "../../project-icons/design/sass-icon.png";
import Vuetify from "../../project-icons/design/vuetify.svg";

const Skills = () => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
    AOS.refresh();
  }, []);
  return (
    <>
      <div className="education-logo">
        <Title title="Skills" />
        <GiSkills className="degree-icon" />
      </div>
      <Title title="Frontend Skills" />
      <section className="skill-section">
        <div className="skill-boxes" data-aos="fade-up">
          <span className="mt-2">
            <img src={WordpressIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Wordpress</p>
          </span>

          <span className="mt-2">
            <img src={WoocommerceIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">WooCommerce</p>
          </span>

          <span className="mt-2">
            <img src={ShopifyIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Shopify Liquid</p>
          </span>

          <span className="mt-2">
            <img src={OpencartIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Opencart</p>
          </span>

          <span className="mt-2">
            <img src={PrestaIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Prestashop</p>
          </span>

          <span className="mt-2">
            <img src={PhpIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">PHP</p>
          </span>

          <span className="mt-2">
            <img src={NextIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Next js</p>
          </span>

          <span className="mt-2">
            <img src={ViteIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Vite</p>
          </span>

          <span className="mt-2">
            <img src={ReactIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">React js</p>
          </span>

          <span className="mt-2">
            <img src={ReduxIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Redux</p>
          </span>

          <span className="mt-2">
            <img src={TypescriptIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Typescript</p>
          </span>

          <span className="mt-2">
            <img src={VueIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Vue js</p>
          </span>

          <span className="mt-2">
            <img src={PiniaIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Pinia</p>
          </span>

          <span className="mt-2">
            <img src={AngularIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Angular js</p>
          </span>

          <span className="mt-2">
            <img src={RxjsIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">RXJS</p>
          </span>

          <span className="mt-2">
            <img src={NodeIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Node js</p>
          </span>
        </div>

        <div className="mb-8"></div>
        <Title title="Backend Skills" />
        <div className="skill-boxes" data-aos="fade-down">
          <span className="mt-2">
            <img src={FirebaseIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Firebase</p>
          </span>

          <span className="mt-2">
            <img src={LaravelIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">php+Laravel</p>
          </span>

          <span className="mt-2">
            <img src={PrismaIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Prisma</p>
          </span>

          <span className="mt-2">
            <img src={MongodbIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Mongodb</p>
          </span>

          <span className="mt-2">
            <img src={NestIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Nest js</p>
          </span>

          <span className="mt-2">
            <img src={TypeOrmIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">TypeORM</p>
          </span>

          <span className="mt-2">
            <img src={PostgresqlIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Postgresql</p>
          </span>

          <span className="mt-2">
            <img src={MariaDBIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Maria DB</p>
          </span>

          <span className="mt-2">
            <img src={MysqlIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">MySql</p>
          </span>

          <span className="mt-2">
            <img src={GraphCMSIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">HyGraph CMS</p>
          </span>

          <span className="mt-2">
            <img src={SanityIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Sanity</p>
          </span>

          <span className="mt-2">
            <img src={GraphQLIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">GraphQL</p>
          </span>

          <span className="mt-2">
            <img src={PostmanIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Postman</p>
          </span>

          <span className="mt-2">
            <img src={HttpIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">HTTP</p>
          </span>

          <span className="mt-2">
            <img src={ApiIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">API</p>
          </span>

          <span className="mt-2">
            <img src={StripeIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Stripe</p>
          </span>
        </div>

        <div className="mb-8"></div>
        <Title title="Testing Skills" />
        <div className="skill-boxes" data-aos="fade-up">
          <span className="mt-2">
            <img src={JestIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Jest</p>
          </span>

          <span className="mt-2">
            <img src={JasmineIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Jasmine</p>
          </span>

          <span className="mt-2">
            <img src={CypressIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Cypress</p>
          </span>

          <span className="mt-2">
            <img src={KarmaIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Karma</p>
          </span>
        </div>

        <div className="mb-8"></div>
        <Title title="Design Skills" />
        <div className="skill-boxes" data-aos="fade-down">
          <span className="mt-2">
            <img src={CSSIcon} alt="icon-1" className="skill-icon" />
            <p className="skill-name">CSS</p>
          </span>

          <span className="mt-2">
            <img src={Saas} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Saas</p>
          </span>

          <span className="mt-2">
            <img src={MaterialUI} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Material UI</p>
          </span>

          <span className="mt-2">
            <img src={Vuetify} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Vuetify</p>
          </span>

          <span className="mt-2">
            <img src={Tailwind} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Tailwind</p>
          </span>

          <span className="mt-2">
            <img src={StyledComponents} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Styled Components</p>
          </span>

          <span className="mt-2">
            <img src={Figma} alt="icon-1" className="skill-icon" />
            <p className="skill-name">Figma</p>
          </span>
        </div>
      </section>
    </>
  );
};

export default Skills;
